class WishlistButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick() {
    console.log('wishlist-button clicked', this.dataset);
    let event = "remove_from_wishlist"
    const payload = {
        "id": this.dataset.product_id,
        "name": this.dataset.productTitle,
        "brand": "ONLY",
        "category": this.dataset.productCategory,
        "price": this.dataset.productPrice,
        "variant": this.dataset.productVariant
    }

    if(this.dataset.added === "false") {
      event = "add_to_wishlist"
    }

    console.log('event', event);
    console.log('payload', payload);
    Shopify.analytics.publish(event, payload);
  }
}

customElements.define('wishlist-button', WishlistButton);

(function initWishlistCountVisibility() {
  const SELECTOR = '.wishlist-h-count, .wishlist-total-count';

  const getCount = (el) => {
    const fromAttr = el.getAttribute('data-total');
    if (fromAttr !== null && fromAttr !== '') {
      const parsed = parseInt(fromAttr, 10);
      if (Number.isFinite(parsed)) return parsed;
    }
    return parseInt(el.textContent.trim(), 10) || 0;
  };

  const updateEl = (el) => {
    const isEmpty = getCount(el) <= 0;
    el.hidden = false;
    el.classList.toggle('is-empty', isEmpty);
  };

  const observeEl = (el) => {
    if (el.__wishlistCountObserved) return;
    el.__wishlistCountObserved = true;
    updateEl(el);
    new MutationObserver(() => updateEl(el)).observe(el, {
      childList: true,
      characterData: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-total', 'hidden']
    });
  };

  const scan = (root) => {
    if (root.nodeType !== 1) return;
    if (root.matches?.(SELECTOR)) observeEl(root);
    root.querySelectorAll?.(SELECTOR).forEach(observeEl);
  };

  const init = () => {
    scan(document.body);
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach(scan);
      });
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

(function initWishlistEmptyState() {
  const EMPTY_SELECTOR = '.wishlsitnoitem';
  const TEMPLATE_ID = 'wishlist-empty-state-template';

  const syncWishlistEmptyFooter = () => {
    const isEnhanced = Boolean(document.querySelector('.wishlist-empty-state--enhanced'));
    document.body.classList.toggle('wishlist-empty-enhanced', isEnhanced);
  };

  const enhance = (el) => {
    if (el.dataset.wishlistEmptyEnhanced === 'true') return;

    const template = document.getElementById(TEMPLATE_ID);
    if (!template) return;

    el.dataset.wishlistEmptyEnhanced = 'true';
    el.classList.add('wishlist-empty-state--enhanced');
    el.replaceChildren(template.content.cloneNode(true));
    syncWishlistEmptyFooter();
  };

  const scan = (root) => {
    if (root.nodeType !== 1) return;
    if (root.matches?.(EMPTY_SELECTOR)) enhance(root);
    root.querySelectorAll?.(EMPTY_SELECTOR).forEach(enhance);
    syncWishlistEmptyFooter();
  };

  const init = () => {
    scan(document.body);
    syncWishlistEmptyFooter();
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach(scan);
        if (mutation.type === 'childList' || mutation.type === 'attributes') {
          syncWishlistEmptyFooter();
        }
      });
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/**
 * Collection quick category sticky bar behavior
 * - scrolling down: hide
 * - scrolling up: show
 * - scroll stop: show
 */
(function initCollectionQuickCategoryStickyBar() {
  const DESKTOP_BAR_SELECTOR = '.quick_category.hide_on_mob';
  const MOBILE_BAR_SELECTOR = '.collection-toolbar';
  const DESKTOP_MQ = '(min-width: 1000px)';
  const MOBILE_MQ = '(max-width: 999px)';

  const resolveMobileStickyBarEl = () => {
    return document.querySelector(MOBILE_BAR_SELECTOR);
  };

  const getStickyAreaHeight = () => {
    const root = getComputedStyle(document.documentElement);
    const num = (name) => {
      const raw = root.getPropertyValue(name).trim();
      const parsed = parseFloat(raw);
      return Number.isFinite(parsed) ? parsed : 0;
    };
    return Math.max(
      num('--sticky-area-height'),
      num('--wigmix-mobile-header-height'),
      num('--liquid-mobile-header-height'),
      num('--collection-plp-sort-sticky-top-measured'),
    );
  };

  const setupOne = ({ barSelector, resolveBar, mediaQuery }) => {
    const bar =
      typeof resolveBar === 'function' ? resolveBar() : document.querySelector(barSelector);
    if (!bar) return;

    const mq = window.matchMedia(mediaQuery);
    let lastY = window.scrollY || 0;
    let pendingY = lastY;
    let rafId = 0;
    let scrollStopTimer = 0;
    let abortController = null;
    let isHidden = false;
    let isStuck = false;
    let lastDirection = 0; // 1 = down, -1 = up

    const show = () => {
      if (!isHidden) return;
      isHidden = false;
      bar.classList.remove('is-hidden');
    };
    const hide = () => {
      if (isHidden) return;
      isHidden = true;
      bar.classList.add('is-hidden');
    };

    const setStuck = (next) => {
      if (isStuck === next) return;
      isStuck = next;
      bar.classList.toggle('is-stuck', isStuck);

      // When not stuck, always show the bar (avoid weird hidden state near the top).
      if (!isStuck) show();
    };

    const updateStuckState = () => {
      const stickyTop = getStickyAreaHeight();
      const top = bar.getBoundingClientRect().top;

      // Hysteresis prevents flicker near the sticky threshold.
      const STUCK_ENTER_PX = 1;
      const STUCK_LEAVE_PX = 12;

      if (!isStuck) {
        if (top <= stickyTop + STUCK_ENTER_PX) setStuck(true);
      } else {
        if (top > stickyTop + STUCK_LEAVE_PX) setStuck(false);
      }
    };

    const scheduleScrollStopShow = () => {
      window.clearTimeout(scrollStopTimer);
      // Slightly longer debounce avoids flashing on tiny scroll pauses (trackpads/inertia).
      scrollStopTimer = window.setTimeout(() => {
        // Only force-show when the bar is in sticky mode.
        if (isStuck) show();
      }, 260);
    };

    const processScroll = () => {
      rafId = 0;
      const y = pendingY;
      const delta = y - lastY;
      lastY = y;

      updateStuckState();

      // Before the bar becomes sticky, keep it stable (no hide/show).
      if (!isStuck) return;

      const DIRECTION_THRESHOLD = 6;
      if (delta > DIRECTION_THRESHOLD) {
        lastDirection = 1;
        hide();
      } else if (delta < -DIRECTION_THRESHOLD) {
        lastDirection = -1;
        show();
      } else {
        // Ignore micro-movements to prevent jitter.
      }

      // Requirement: when scrolling stops, the bar should show (even if last direction was down).
      scheduleScrollStopShow();
    };

    const onScroll = () => {
      pendingY = window.scrollY || 0;
      if (!rafId) rafId = requestAnimationFrame(processScroll);
    };

    const enable = () => {
      lastY = window.scrollY || 0;
      pendingY = lastY;
      isHidden = bar.classList.contains('is-hidden');
      isStuck = bar.classList.contains('is-stuck');
      lastDirection = 0;
      show();
      updateStuckState();

      abortController?.abort();
      abortController = new AbortController();

      window.addEventListener('scroll', onScroll, { passive: true, signal: abortController.signal });
    };

    const disable = () => {
      abortController?.abort();
      abortController = null;
      if (rafId) cancelAnimationFrame(rafId);
      rafId = 0;
      window.clearTimeout(scrollStopTimer);
      scrollStopTimer = 0;
      show();
      setStuck(false);
    };

    const onMqChange = () => {
      if (mq.matches) enable();
      else disable();
    };

    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', onMqChange);
    } else if (typeof mq.addListener === 'function') {
      // Legacy Safari
      mq.addListener(onMqChange);
    }

    onMqChange();
  };

  const setup = () => {
    setupOne({ barSelector: DESKTOP_BAR_SELECTOR, mediaQuery: DESKTOP_MQ });
    setupOne({
      resolveBar: resolveMobileStickyBarEl,
      mediaQuery: MOBILE_MQ,
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();


/**
 * PWA bottom nav sits above drawer overlays on mobile, but open drawers still trap
 * touch events. Allow one-tap navigation for Home / Wishlist / Account, but not for
 * the item that toggles the same open drawer (menu or cart) — those must close
 * via the theme toggle without reopening.
 */
(function initPwaBottomNavDrawerClickThrough() {
  const PWA_LINK_SELECTOR = '.pwa-mob-menu';
  const PWA_DRAWER_IDS = ['sidebar-menu', 'cart-drawer'];

  const patchDialogElement = () => {
    const dialogProto = customElements.get('dialog-element')?.prototype;
    if (!dialogProto || dialogProto.__pwaOutsideClickPatched) return;

    const originalAllow = dialogProto.allowOutsideClickForTarget;
    const originalHideTarget = dialogProto.hideForOutsideClickTarget;

    dialogProto.allowOutsideClickForTarget = function (target) {
      const pwaLink = target?.closest?.(PWA_LINK_SELECTOR);
      if (!pwaLink) {
        return originalAllow.call(this, target);
      }

      const controlsId = pwaLink.getAttribute('aria-controls');
      if (controlsId && controlsId === this.id) {
        return false;
      }

      return true;
    };

    dialogProto.hideForOutsideClickTarget = function (target) {
      const pwaLink = target?.closest?.(`${PWA_LINK_SELECTOR}[aria-controls]`);
      if (pwaLink) {
        const controlsId = pwaLink.getAttribute('aria-controls');
        if (controlsId && controlsId !== this.id && PWA_DRAWER_IDS.includes(controlsId)) {
          return false;
        }
      }

      return originalHideTarget.call(this, target);
    };

    dialogProto.__pwaOutsideClickPatched = true;
  };

  if (customElements.get('dialog-element')) {
    patchDialogElement();
  } else {
    customElements.whenDefined('dialog-element').then(patchDialogElement);
  }
})();

/**
 * Reliable toggle for PWA menu / cart icons (open ↔ close on repeated tap).
 * When switching sidebar ↔ cart, open the new drawer instantly, then close the other (no slide animation).
 */
(function initPwaBottomNavDrawerToggle() {
  const PWA_LINK_SELECTOR = '.pwa-mob-menu[aria-controls]';
  const PWA_DRAWER_IDS = ['sidebar-menu', 'cart-drawer'];
  const SWITCHING_CLASS = 'pwa-drawer-switching';

  const getOtherOpenDrawers = (target) =>
    PWA_DRAWER_IDS.map((id) => document.getElementById(id)).filter(
      (drawer) => drawer && drawer !== target && drawer.open
    );

  document.addEventListener(
    'click',
    async (event) => {
      const link = event.target.closest(PWA_LINK_SELECTOR);
      if (!link) return;

      const drawerId = link.getAttribute('aria-controls');
      const drawer = drawerId ? document.getElementById(drawerId) : null;
      if (!drawer || typeof drawer.hide !== 'function' || typeof drawer.show !== 'function') {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      try {
        if (drawer.open) {
          await drawer.hide();
          return;
        }

        const othersOpen = getOtherOpenDrawers(drawer);

        if (othersOpen.length > 0) {
          document.documentElement.classList.add(SWITCHING_CLASS);
          drawer.classList.add('pwa-drawer-incoming');
          try {
            const showPromise = drawer.show(false);
            await Promise.all(othersOpen.map((other) => other.hide()));
            await showPromise;
          } finally {
            drawer.classList.remove('pwa-drawer-incoming');
            document.documentElement.classList.remove(SWITCHING_CLASS);
          }
          return;
        }

        await drawer.show();
      } catch (error) {
        console.error('PWA drawer toggle failed', error);
      }
    },
    true
  );
})();

/**
 * ViSenze wigmix scanner icon lives in shadow DOM — hide unless html.canvas-app.
 */
(function initWigmixScannerVisibility() {
  const WIDGET_SELECTOR = '.ps-widget-10533';
  const STYLE_ID = 'only-wigmix-scanner-visibility';
  const HIDE_RULE =
    'svg[data-icon-scanner="true"] {' +
    'display: none !important;' +
    'visibility: hidden !important;' +
    'pointer-events: none !important;' +
    '}';

  const isCanvasApp = () => document.documentElement.classList.contains('canvas-app');

  const collectShadowRoots = (widget) => {
    const roots = [];

    const walk = (node) => {
      if (!node || typeof node.querySelectorAll !== 'function') return;

      node.querySelectorAll('*').forEach((el) => {
        if (!el.shadowRoot || roots.includes(el.shadowRoot)) return;
        roots.push(el.shadowRoot);
        walk(el.shadowRoot);
      });
    };

    if (widget.shadowRoot) {
      roots.push(widget.shadowRoot);
      walk(widget.shadowRoot);
    }

    walk(widget);
    return roots;
  };

  const syncShadowRoot = (root) => {
    let style = root.getElementById(STYLE_ID);
    if (!isCanvasApp()) {
      if (!style) {
        style = document.createElement('style');
        style.id = STYLE_ID;
        root.appendChild(style);
      }
      style.textContent = HIDE_RULE;
      return;
    }
    if (style) style.remove();
  };

  const syncAll = () => {
    document.querySelectorAll(WIDGET_SELECTOR).forEach((widget) => {
      collectShadowRoots(widget).forEach(syncShadowRoot);
    });
  };

  new MutationObserver(syncAll).observe(document.body, {
    childList: true,
    subtree: true,
  });

  new MutationObserver(syncAll).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class'],
  });

  syncAll();
  window.setTimeout(syncAll, 500);
  window.setTimeout(syncAll, 1500);
  window.setTimeout(syncAll, 3000);
})();

/**
 * ViSenze re-focuses/re-renders its shadow-root search input while typing.
 * On desktop this can make the browser scroll the page upward to keep that
 * focused input in view. Keep the user's current page position stable.
 */
(function initViSenzeDesktopSearchScrollGuard() {
  const DESKTOP_WIDGET_SELECTOR = '.ps-widget-10533.expandable.wide-search-overlay';
  const SEARCH_INPUT_SELECTOR =
    '[data-pw="msb-search-bar-input"], [data-testid="wigmix-msb-search-bar-input"]';
  const DESKTOP_MQ = window.matchMedia('(min-width: 1000px)');

  const closestAcrossShadowRoots = (node, selector) => {
    let current = node;

    while (current) {
      if (current.nodeType === 1 && current.matches?.(selector)) return current;

      if (current.assignedSlot) {
        current = current.assignedSlot;
      } else if (current.parentElement) {
        current = current.parentElement;
      } else {
        const root = current.getRootNode?.();
        current = root?.host || null;
      }
    }

    return null;
  };

  const isGuardedInput = (node) => {
    return Boolean(
      DESKTOP_MQ.matches &&
        node?.matches?.(SEARCH_INPUT_SELECTOR) &&
        closestAcrossShadowRoots(node, DESKTOP_WIDGET_SELECTOR)
    );
  };

  const findGuardedInputInEvent = (event) => {
    return event.composedPath?.().find(isGuardedInput) || null;
  };

  const getDeepActiveElement = () => {
    let active = document.activeElement;

    while (active?.shadowRoot?.activeElement) {
      active = active.shadowRoot.activeElement;
    }

    return active;
  };

  const restoreIfWidgetMovedPage = (scrollX, scrollY) => {
    const active = getDeepActiveElement();
    if (!isGuardedInput(active)) return;

    // Only undo upward movement caused by the widget. Let real user scrolls pass.
    if (window.scrollY < scrollY - 1) {
      window.scrollTo({ left: scrollX, top: scrollY, behavior: 'auto' });
    }
  };

  const preserveScrollDuringInput = (event) => {
    if (!findGuardedInputInEvent(event)) return;

    const scrollX = window.scrollX;
    const scrollY = window.scrollY;

    requestAnimationFrame(() => restoreIfWidgetMovedPage(scrollX, scrollY));
    window.setTimeout(() => restoreIfWidgetMovedPage(scrollX, scrollY), 0);
    window.setTimeout(() => restoreIfWidgetMovedPage(scrollX, scrollY), 80);
  };

  ['keydown', 'beforeinput', 'input', 'keyup'].forEach((eventName) => {
    document.addEventListener(eventName, preserveScrollDuringInput, true);
  });

  const originalFocus = HTMLElement.prototype.focus;
  if (!originalFocus.__visenzeDesktopSearchGuarded) {
    HTMLElement.prototype.focus = function focusWithViSenzeScrollGuard(options) {
      if (isGuardedInput(this)) {
        const nextOptions =
          options && typeof options === 'object'
            ? { ...options, preventScroll: true }
            : { preventScroll: true };

        return originalFocus.call(this, nextOptions);
      }

      return originalFocus.apply(this, arguments);
    };

    HTMLElement.prototype.focus.__visenzeDesktopSearchGuarded = true;
  }

  const originalScrollIntoView = Element.prototype.scrollIntoView;
  if (!originalScrollIntoView.__visenzeDesktopSearchGuarded) {
    Element.prototype.scrollIntoView = function scrollIntoViewWithViSenzeGuard() {
      if (isGuardedInput(this)) return;

      return originalScrollIntoView.apply(this, arguments);
    };

    Element.prototype.scrollIntoView.__visenzeDesktopSearchGuarded = true;
  }
})();

document.addEventListener('DOMContentLoaded', function() {
  var backToTopButton = document.querySelector('[data-back-to-top]');

  if (!backToTopButton) return;

  var SHOW_OFFSET = 400; // pixels

  function toggleBackToTopVisibility() {
    if (window.scrollY > SHOW_OFFSET) {
      backToTopButton.classList.add('back-to-top--visible');
    } else {
      backToTopButton.classList.remove('back-to-top--visible');
    }
  }

  window.addEventListener('scroll', toggleBackToTopVisibility, { passive: true });

  toggleBackToTopVisibility();

  backToTopButton.addEventListener('click', function() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });
});

// -----------------------------------------------------------------------------
// CUSTOMER INVOICE LIST (ONLINE / OFFLINE)
// -----------------------------------------------------------------------------

document.addEventListener('DOMContentLoaded', function () {
  var invoiceSection = document.querySelector('.invoice-section[data-invoice-endpoint]');
  if (!invoiceSection) return;

  var phone = invoiceSection.getAttribute('data-invoice-phone') || '';
  var store = invoiceSection.getAttribute('data-invoice-store') || '';
  var endpoint = invoiceSection.getAttribute('data-invoice-endpoint') || '';

  // If phone is missing, Liquid has already rendered a helpful message.
  if (!phone || !endpoint || !store) return;

  var cache = {
    online: null,
    offline: null
  };
  var currentType = 'online';

  var tabs = invoiceSection.querySelectorAll('.invoice-tab');
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var type = tab.getAttribute('data-invoice-type');
      if (!type || type === currentType) return;

      currentType = type;
      tabs.forEach(function (innerTab) {
        innerTab.classList.toggle('is-active', innerTab === tab);
      });

      loadInvoices(type);
    });
  });

  // Load Website (online) by default
  loadInvoices('online');

  function loadInvoices(type) {
    var tbody = invoiceSection.querySelector('.invoice-table-body');
    var errorEl = invoiceSection.querySelector('.invoice-error');
    var emptyMessageEl = invoiceSection.querySelector('.invoice-empty-message');
    var table = invoiceSection.querySelector('.invoice-table');
    if (!tbody || !errorEl) return;

    if (table) {
      table.classList.toggle('invoice-table--offline', type === 'offline');
    }

    errorEl.style.display = 'none';
    errorEl.textContent = '';
    if (emptyMessageEl) {
      emptyMessageEl.style.display = 'none';
      emptyMessageEl.textContent = '';
    }
    tbody.innerHTML =
      '<tr><td colspan="6">Loading ' + (type === 'online' ? 'website' : 'offline') + ' invoices&hellip;</td></tr>';

    if (cache[type]) {
      renderInvoices(cache[type], type);
      return;
    }

    try {
      var url = new URL(endpoint);
      url.searchParams.set('phone', phone);
      url.searchParams.set('store', store);
      url.searchParams.set('type', type);

      // Do not send credentials so the API can use a simple wildcard CORS policy.
      fetch(url.toString())
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then(function (data) {
          if (!data || data.success !== true || !Array.isArray(data.data)) {
            throw new Error('Unexpected API response');
          }

          cache[type] = data.data;
          renderInvoices(cache[type], type);
        })
        .catch(function (error) {
          console.error('Error fetching invoices', error);
          tbody.innerHTML = '';
          errorEl.textContent = 'Unable to load invoices at the moment. Please try again later.';
          errorEl.style.display = 'block';
          if (emptyMessageEl) {
            emptyMessageEl.style.display = 'none';
            emptyMessageEl.textContent = '';
          }
        });
    } catch (e) {
      console.error('Error building invoice URL', e);
    }
  }

  function renderInvoices(list, type) {
    var tbody = invoiceSection.querySelector('.invoice-table-body');
    var emptyMessageEl = invoiceSection.querySelector('.invoice-empty-message');
    if (!tbody) return;

    if (!list || list.length === 0) {
      var message =
        type === 'offline'
          ? 'You do not have any in-store purchases yet.'
          : 'You do not have any online orders yet.';

      // Do not render an empty table row; just show the helper text below.
      tbody.innerHTML = '';

      if (emptyMessageEl) {
        emptyMessageEl.textContent = message;
        emptyMessageEl.style.display = 'block';
      }

      return;
    }

    tbody.innerHTML = '';

    if (emptyMessageEl) {
      emptyMessageEl.style.display = 'none';
      emptyMessageEl.textContent = '';
    }

    list.forEach(function (item) {
      var tr = document.createElement('tr');
      var orderNumber = item.salesOrderNumber || '';
      var invoiceNumber = item.invoiceNumber || '';
      var purchaseDate = formatInvoiceDate(item.purchaseDate);
      var amount = item.paidAmount || '';
      var invoiceDate = formatInvoiceDate(item.invoiceDate);
      var url = item.invoiceUrl || '';

      tr.innerHTML =
        '<td>' + escapeHtml(orderNumber) + '</td>' +
        '<td>' + escapeHtml(invoiceNumber) + '</td>' +
        '<td>' + escapeHtml(purchaseDate) + '</td>' +
        '<td>' + escapeHtml(amount) + '</td>' +
        '<td>' + escapeHtml(invoiceDate) + '</td>' +
        '<td class="text-end">' +
        (url
          ? '<a href="' + encodeURI(url) + '" target="_blank" rel="noopener" class="link-faded">View invoice</a>'
          : '') +
        '</td>';

      tbody.appendChild(tr);
    });
  }

  function formatInvoiceDate(raw) {
    if (!raw) return '';

    var value = String(raw).trim();

    // Handle explicit string patterns first so we don't let `new Date`
    // guess and potentially swap day & month for values like 11.03.2023.

    // Pattern like "27.12.2025" or "27.12.2025 20:24:02" (dd.MM.yyyy)
    var dotMatch = value.match(/^(\d{2})\.(\d{2})\.(\d{4})/);
    if (dotMatch) {
      return dotMatch[1] + '/' + dotMatch[2] + '/' + dotMatch[3];
    }

    // Pattern like "2025-12-27" or "2025-12-27T15:00:25.995" (yyyy-MM-dd)
    var dashMatch = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (dashMatch) {
      return dashMatch[3] + '/' + dashMatch[2] + '/' + dashMatch[1];
    }

    // As a fallback, let the browser parse the date string if it can.
    var d = new Date(value);
    if (!isNaN(d.getTime())) {
      var dd = String(d.getDate()).padStart(2, '0');
      var mm = String(d.getMonth() + 1).padStart(2, '0');
      var yyyy = d.getFullYear();
      return dd + '/' + mm + '/' + yyyy;
    }

    // Last resort: return the original raw value
    return value;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) {
      switch (char) {
        case '&':
          return '&amp;';
        case '<':
          return '&lt;';
        case '>':
          return '&gt;';
        case '"':
          return '&quot;';
        default:
          return '&#39;';
      }
    });
  }
});